/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Uppercase_Speaker_LabelsInputs */

const en_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removes speaker labels in uppercase`)
};

const fr_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprime les libellés d’intervenant en majuscules`)
};

const de_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernt Lautsprecherbezeichnungen in Großbuchstaben`)
};

const it_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuove le etichette degli altoparlanti in maiuscolo`)
};

const ru_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаляет надписи на динамиках, написанные заглавными буквами.`)
};

const es_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina las etiquetas de los altavoces en mayúsculas`)
};

const zh_cn2_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除大写的扬声器标签`)
};

const ja_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字のスピーカーラベルを削除します`)
};

const hi_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर लेबल के बड़े अक्षरों को हटाता है`)
};

const pt_pt2_remove_uppercase_speaker_labels = /** @type {(inputs: Remove_Uppercase_Speaker_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove as etiquetas dos alto-falantes em maiúsculas.`)
};

/**
* | output |
* | --- |
* | "Removes speaker labels in uppercase" |
*
* @param {Remove_Uppercase_Speaker_LabelsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_uppercase_speaker_labels = /** @type {((inputs?: Remove_Uppercase_Speaker_LabelsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Uppercase_Speaker_LabelsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_uppercase_speaker_labels(inputs)
	if (locale === "de") return de_remove_uppercase_speaker_labels(inputs)
	if (locale === "it") return it_remove_uppercase_speaker_labels(inputs)
	if (locale === "ru") return ru_remove_uppercase_speaker_labels(inputs)
	if (locale === "es") return es_remove_uppercase_speaker_labels(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_uppercase_speaker_labels(inputs)
	if (locale === "ja") return ja_remove_uppercase_speaker_labels(inputs)
	if (locale === "hi") return hi_remove_uppercase_speaker_labels(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_uppercase_speaker_labels(inputs)
	return en_remove_uppercase_speaker_labels(inputs)
});